import React, { createRef, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { deleteComment, loadComments, updateComment } from '../store/comments/actions';

import { Panel } from 'react-bootstrap';

import LoadingSpinner from 'components/loading_spinner';
import Comment from './comment';
import Input from './input';
import CommentModal from './modal';
import { scrollToRef } from 'helpers/scrolling';

import './styles.scss';

export function DealComments({ comments, deleteComment, loadComments, loading, updateComment }) {
  const commentsEndRef = createRef();
  const [scrollBehavior, setScrollBehavior] = useState('instant');
  const [modalComment, setModalComment] = useState(null);

  React.useEffect(() => {
    if (comments) {
      scrollToRef(commentsEndRef, { behavior: scrollBehavior });
      setScrollBehavior('smooth');
    } else {
      loadComments();
    }
  }, []);

  React.useEffect(() => {
    scrollToRef(commentsEndRef, { behavior: scrollBehavior });

    if (comments) {
      setScrollBehavior('smooth');
    }
  }, [comments]);

  const todayComments = [];
  const olderComments = [];

  if (comments) {
    comments.forEach((comment) => {
      if (new Date(comment.createdAt).toDateString() == new Date().toDateString()) {
        todayComments.push(comment);
      } else {
        olderComments.push(comment);
      }
    });
  }

  return (
    <Panel className="deal-comments-sidebar">
      <Panel.Heading>
        <h3 className="m-0">Messages</h3>
      </Panel.Heading>

      <Panel.Body>
        {loading ? (
          <LoadingSpinner/>
        ) : (
          <div className="deal-comments-container flex-1">
            {olderComments.map((comment, i) => (
              <Comment comment={comment} key={i} onDelete={deleteComment} onEdit={()=>setModalComment(comment)}/>
            ))}
            {todayComments.length > 0 && (
              <div className="today-divider">
                <div className="divider-line" />
                <div className="text-muted mx-2">Today</div>
                <div className="divider-line" />
              </div>
            )}
            {todayComments.map((comment, i) => (
              <Comment comment={comment} key={i} today onDelete={deleteComment} onEdit={()=>setModalComment(comment)}/>
            ))}
            <span ref={commentsEndRef} />
          </div>
        )}
        <CommentModal
          comment={modalComment}
          show={!!modalComment}
          updateComment={updateComment}
          onHide={() => setModalComment(null)}
        />
      </Panel.Body>

      <Panel.Footer>
        <Input submitOnEnter/>
      </Panel.Footer>
    </Panel>
  );
}

DealComments.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.shape({
    createdAt: PropTypes.string.isRequired
  })),
  deleteComment: PropTypes.func.isRequired,
  loadComments: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  updateComment: PropTypes.func.isRequired,
};

const mapStateToProps = ({ comments: { comments, loading } }) => ({
  comments,
  loading,
});

const mapDispatchToProps = {
  deleteComment,
  loadComments,
  updateComment,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealComments);
